<template>
  <v-container fluid>
    <v-row
      justify="space-between"
      class="mb-2"
    >
      <v-col>
        <v-btn
          color="primary"
          @click="showDialogAddEmail"
          v-if="userAccess.canCreate"
        >
          {{ $_strings.email.add }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="5" md="4">
        <v-text-field
          dense
          hide-details
          outlined
          :placeholder="$_strings.email.searchText"
          v-model="searchText"
          @keyup.enter="search"
        >
          <template v-slot:prepend-inner>
            <v-icon @click="search"> mdi-magnify </v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :loading="isLoading"
          :headers="displayedHeaders"
          :items="items"
          item-key="id"
          :server-items-length="totalItems"
          class="body"
          :sort-by.sync="sortBy"
          :sort-desc.sync="desc"
          :options.sync="pagination"
          :footer-props="{showCurrentPage: true, showFirstLastPage: true, 'items-per-page-options': $_item_per_page}">
          <template v-slot:[`item.picName`]=items>
            <span>{{ items.item.picName }}</span>
          </template>
          <template v-slot:[`item.createdBy`]=items>
            <span>{{ items.item.createdBy }}</span>
            <br/>
            <span>{{ dateFormat(items.item.createdAt) }}</span>
          </template>
          <template v-slot:[`item.actions`]={item}>
            <v-tooltip v-if="userAccess.canUpdate" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn  v-bind="attrs" v-on="on" x-small icon class="mr-2" color="primary" @click="showDialogAddEmail(item)" >
                  <v-icon> mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip v-if="userAccess.canDelete" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn  v-bind="attrs" v-on="on" x-small icon color="red" @click="()=> deleteEmail(item)" @click.stop.prevent>
                  <v-icon> mdi-trash-can </v-icon>
                </v-btn>
              </template>
              <span>Hapus</span>
            </v-tooltip>
          </template>
          <template v-slot:[`footer.page-text`]="props">
            <span>
              {{$_strings.email.pageName}}
              <span v-if="items.length">
                {{props.pageStart}}-{{props.pageStop}} of {{props.itemsLength}}
              </span>
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <AddEmail
      ref="dialogAddEmail"
      @fetchEmail="fetchEmail"
    />
  </v-container>
</template>

<script>
import {
  dateFormat,
  skipEmptyStringObject,
  handleSortBy,
  handlerPagination,
  defaultPagination,
} from '@/helper/commonHelpers';
import AddEmail from './Dialog/AddEmail.vue';

export default {
  picName: 'email',
  components: {
    AddEmail,
  },
  data() {
    return {
      isLoading: false,
      dialogAddEmail: false,
      dialogEditEmail: false,
      desc: true,
      items: [],
      temporary: {},
      sortBy: 'createdAt',
      searchText: '',
      headers: [
        {
          text: this.$_strings.email.nameLabel,
          value: 'picName',
          class: 'white--text primary text-capitalize',
        },
        {
          text: this.$_strings.email.emailLabel,
          value: 'email',
          class: 'white--text primary text-capitalize',
        },
        {
          text: this.$_strings.email.createdBy,
          value: 'createdBy',
          class: 'white--text primary text-capitalize',
        },
        {
          text: 'Aksi',
          value: 'actions',
          class: 'white--text primary text-capitalize',
          sortable: false,
        },
      ],
      pagination: this.defaultPagination(),
      totalItems: 10,
    };
  },
  computed: {
    displayedHeaders() {
      const { canUpdate, canDelete } = this.userAccess;
      return this.headers.filter((header) => {
        if (header.value === 'actions' && !canUpdate && !canDelete) return;
        return header;
      });
    },
  },
  watch: {
    pagination: {
      handler(newVal) {
        this.handlerPagination(this, newVal);
        this.fetchEmail();
      },
      deep: true,
    },
  },
  methods: {
    dateFormat,
    skipEmptyStringObject,
    handleSortBy,
    handlerPagination,
    defaultPagination,
    showDialogAddEmail(item = {}) {
      this.$refs.dialogAddEmail.dialog = true;
      if (item) {
        this.$refs.dialogAddEmail.id = item.id;
        this.$refs.dialogAddEmail.form.email = item.email;
        this.$refs.dialogAddEmail.form.picName = item.picName;
      }
    },
    search() {
      if (this.pagination.page > 1) {
        this.pagination.page = 1;
        return;
      }
      this.fetchEmail();
    },
    fetchEmail() {
      this.isLoading = true;
      const {
        page, itemsPerPage, sortBy, sortDesc,
      } = this.pagination;
      const filters = {
        page: page - 1,
        size: itemsPerPage,
        email: this.searchText,
        sort: this.handleSortBy({ defaultValue: 'createdAt,DESC', sortBy, sortDesc }),
      };
      if (filters.email) filters.email = `qLike(${filters.email})`;
      this.$_services.email.getListEmail(this.skipEmptyStringObject(filters))
        .then((result) => {
          this.items = result.data.contents;
          this.totalItems = result.data.totalData;
        }).finally(() => {
          this.isLoading = false;
        });
    },
    deleteEmail(item) {
      this.$dialog.warning({
        text: this.$_strings.email.deleteEmailConfirmMsg,
        title: this.$_strings.common.WARNING,
        persistent: true,
        actions: {
          false: this.$_strings.common.NO,
          true: this.$_strings.common.YES,
        },
      }).then((emailRes) => {
        if (emailRes) {
          this.$root.$loading.show();
          this.$_services.email.deleteEmail(item.id)
            .then((res) => {
              this.$dialog.notify.success(this.$_strings.email.SUCCESS_DELETE_EMAIL_MESSAGE_TEXT);
              this.items.splice(this.items.indexOf(item), 1);
            }).finally(() => {
              this.$root.$loading.hide();
            });
        }
      });
    },
  },
};
</script>
